import { MAPPING_READ, MAPPING_CREATE } from "./index";

const initialState = {
  result: {},
  loaded: false,
  error: null
};

export default function auth(state = initialState, action = {}) {
  const { type, payload, error } = action;

  if (error) {
    return {
      ...state,
      error: payload
    };
  }

  switch (type) {
    case MAPPING_READ:
      return {
        ...state,
        result: payload,
        loaded: true,
        error: null
      };

    case MAPPING_CREATE:
      return {
        ...state,
        loaded: true,
        error: null
      };

    default:
      return state;
  }
}
